import { render, staticRenderFns } from "./applySecureUpgrade.vue?vue&type=template&id=940d4342&scoped=true&"
import script from "./applySecureUpgrade.vue?vue&type=script&lang=tsx&"
export * from "./applySecureUpgrade.vue?vue&type=script&lang=tsx&"
import style0 from "./applySecureUpgrade.vue?vue&type=style&index=0&id=940d4342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940d4342",
  null
  
)

export default component.exports